/* eslint-disable no-case-declarations */
import moment from 'moment';
import { combineReducers } from 'redux';
import { nanoid } from 'nanoid';
import {
  NOTIFICATION_ADD_ENTRY,
  NOTIFICATION_DELETE_ENTRY,
  NOTIFICATION_CLEAR_ALL,
  ORDER_UPDATE_ENTRY,
} from '../constants/ActionTypes';

import { soundPlay } from '../helpers/sound-play';

const statusToLevel = {
  complete: 'success',
  rejected: 'error',
  modified: 'info',
  cancelled: 'info',
  'modify rejected': 'error',
};

const list = (state = { data: [] }, action) => {
  switch (action.type) {
    case NOTIFICATION_ADD_ENTRY:
      const { data: dataAddEntry = [] } = state;

      action.data.timestamp = moment.utc().valueOf();

      dataAddEntry.unshift({ ...action.data, id: nanoid() });

      if (action.data.type && !action.data.silent) {
        soundPlay({ type: action.data.type });
      }

      return {
        ...state,
        data: dataAddEntry,
      };
    case ORDER_UPDATE_ENTRY:
      const { data: dataAddOrderEntry = [] } = state;
      const orderStatus = action.data;
      const { status = '' } = orderStatus;

      // ignore open pending and open
      if (status === 'open pending' || status === 'open') {
        return {
          ...state,
        };
      }

      if (status === 'modify_rejected') {
        orderStatus.status = 'modify rejected';
      }

      const metaData = {
        type: statusToLevel[orderStatus.status]
          ? statusToLevel[orderStatus.status]
          : 'info',
        message: 'check',
        orderUpdate: true,
        orderStatus: {
          ...orderStatus,
        },
        timestamp: moment.utc().valueOf(),
      };

      dataAddOrderEntry.unshift({ ...metaData, id: nanoid() });

      if (metaData.type && !metaData.silent) {
        soundPlay({ type: metaData.type });
      }

      return {
        ...state,
        data: dataAddOrderEntry,
      };
    case NOTIFICATION_DELETE_ENTRY:
      let { data: dataDeleteEntry = [] } = state;
      dataDeleteEntry = dataDeleteEntry.filter((d) => d.id !== action.data.id);

      return {
        ...state,
        data: dataDeleteEntry,
      };
    case NOTIFICATION_CLEAR_ALL:
      return {
        ...state,
        data: [],
      };
    default:
      return state;
  }
};

const notifications = combineReducers({
  list,
});

export default notifications;
